import UserValidationModel from './userValidation'
import { ObjectWithDefault } from '../../utils/objectWithDefault'

export default class UserDetailsModel extends UserValidationModel {
  constructor (u) {
    super()
    const defaultImpersontedUser = {
      AccountManager: { val: '', type: String },
      ActiveRules: { val: false, type: Boolean },
      CarrierServicesEnabled: { val: false, type: Boolean },
      CityId: { val: 0, type: Number },
      CompanyName: { val: '', type: String },
      CompanyWebsite: { val: '', type: String },
      CreditCardOnFile: { val: false, type: Boolean },
      CustomerServiceManager: { val: '', type: String },
      DefaultStoreIntegrationId: { val: -1, type: Number },
      DomesticPricingPlanId: { val: 0, type: Number },
      Email: { val: '', type: String },
      EmailOptIn: { val: false, type: Boolean },
      EstimatedSKUCount: { val: 0, type: Number },
      FirstName: { val: '', type: String },
      HasShippedAnOrder: { val: false, type: Boolean },
      HasURO: { val: false, type: Boolean },
      InsertDate: { val: '', type: String },
      InternationalPricingPlanId: { val: 0, type: Number },
      IsAdmin: { val: false, type: Boolean },
      IsDemoUser: { val: false, type: Boolean },
      IsLive: { val: false, type: Boolean },
      IsOnboarding: { val: false, type: Boolean },
      LastCompletedStep: { val: 8, type: Number },
      LastCompletedStepName: { val: '', type: String },
      LastName: { val: '', type: String },
      LastSeen: { val: '', type: String },
      NumberOfIntegrations: { val: 0, type: Number },
      NumberOfRecievedWRO: { val: 0, type: Number },
      NumberOfShipmentsPerMonth: { val: 0, type: Number },
      OneDayEnabled: { val: false, type: Boolean },
      PhoneNumber: { val: '', type: String },
      ShipOptionsSet: { val: false, type: Boolean },
      StoreIntegrationNames: { val: '', type: String },
      TwoDayEnabled: { val: false, type: Boolean },
      UserGrowthExperimentId: { val: 0, type: Number },
      UserId: { val: 0, type: Number },
      UserRole: { val: 0, type: Number },
      WhenReadyToShip: { val: '', type: String }
    }
    const impersonatedUser = ObjectWithDefault(defaultImpersontedUser, u)
    this.accountManager = impersonatedUser.AccountManager
    this.activeRules = impersonatedUser.ActiveRules
    this.carrierServicesEnabled = impersonatedUser.CarrierServicesEnabled
    this.cityId = impersonatedUser.CityId
    this.companyName = impersonatedUser.CompanyName
    this.companyWebsite = impersonatedUser.CompanyWebsite
    this.creditCardOnFile = impersonatedUser.CreditCardOnFile
    this.customerServiceManager = impersonatedUser.CustomerServiceManager
    this.defaultStoreIntegrationId = impersonatedUser.DefaultStoreIntegrationId
    this.domesticPricingPlanId = impersonatedUser.DomesticPricingPlanId
    this.email = impersonatedUser.Email
    this.emailOptIn = impersonatedUser.EmailOptIn
    this.estimatedSKUCount = impersonatedUser.EstimatedSKUCount
    this.firstName = impersonatedUser.FirstName
    this.hasShippedAnOrder = impersonatedUser.HasShippedAnOrder
    this.hasURO = impersonatedUser.HasURO
    this.insertDate = impersonatedUser.InsertDate
    this.internationalPricingPlanId = impersonatedUser.InternationalPricingPlanId
    this.isAdmin = impersonatedUser.IsAdmin
    this.isDemoUser = impersonatedUser.IsDemoUser
    this.isLive = impersonatedUser.IsLive
    this.isOnboarding = impersonatedUser.IsOnboarding
    this.lastCompletedStep = impersonatedUser.LastCompletedStep
    this.lastCompletedStepName = impersonatedUser.LastCompletedStepName
    this.lastName = impersonatedUser.LastName
    this.lastSeen = impersonatedUser.LastSeen
    this.numberOfIntegrations = impersonatedUser.NumberOfIntegrations
    this.numberOfRecievedWRO = impersonatedUser.NumberOfRecievedWRO
    this.numberOfShipmentsPerMonth = impersonatedUser.NumberOfShipmentsPerMonth
    this.oneDayEnabled = impersonatedUser.OneDayEnabled
    this.phoneNumber = impersonatedUser.PhoneNumber
    this.shipOptionsSet = impersonatedUser.ShipOptionsSet
    this.storeIntegrationNames = impersonatedUser.StoreIntegrationNames
    this.twoDayEnabled = impersonatedUser.TwoDayEnabled
    this.userGrowthExperimentId = impersonatedUser.UserGrowthExperimentId
    this.userId = impersonatedUser.UserId
    this.userRole = impersonatedUser.UserRole
    this.whenReadyToShip = impersonatedUser.WhenReadyToShip
  }

  get accountManager () {
    return this.mapAttributeGetter('accountManager')
  }

  set accountManager (val) {
    this.mapAttributeSetter('accountManager', val)
  }

  get activeRules () {
    return this.mapAttributeGetter('activeRules')
  }

  set activeRules (val) {
    this.mapAttributeSetter('activeRules', val)
  }

  get carrierServicesEnabled () {
    return this.mapAttributeGetter('carrierServicesEnabled')
  }

  set carrierServicesEnabled (val) {
    this.mapAttributeSetter('carrierServicesEnabled', val)
  }

  get cityId () {
    return this.mapAttributeGetter('cityId')
  }

  set cityId (val) {
    this.mapAttributeSetter('cityId', val)
  }

  get companyName () {
    return this.mapAttributeGetter('companyName')
  }

  set companyName (val) {
    this.mapAttributeSetter('companyName', val)
  }

  get companyWebsite () {
    return this.mapAttributeGetter('companyWebsite')
  }

  set companyWebsite (val) {
    this.mapAttributeSetter('companyWebsite', val)
  }

  get creditCardOnFile () {
    return this.mapAttributeGetter('creditCardOnFile')
  }

  set creditCardOnFile (val) {
    this.mapAttributeSetter('creditCardOnFile', val)
  }

  get customerServiceManager () {
    return this.mapAttributeGetter('customerServiceManager')
  }

  set customerServiceManager (val) {
    this.mapAttributeSetter('customerServiceManager', val)
  }

  get defaultStoreIntegrationId () {
    return this.mapAttributeGetter('defaultStoreIntegrationId')
  }

  set defaultStoreIntegrationId (val) {
    this.mapAttributeSetter('defaultStoreIntegrationId', val)
  }

  get domesticPricingPlanId () {
    return this.mapAttributeGetter('domesticPricingPlanId')
  }

  set domesticPricingPlanId (val) {
    this.mapAttributeSetter('domesticPricingPlanId', val)
  }

  get email () {
    return this.mapAttributeGetter('email')
  }

  set email (val) {
    this.mapAttributeSetter('email', val)
  }

  get emailOptIn () {
    return this.mapAttributeGetter('emailOptIn')
  }

  set emailOptIn (val) {
    this.mapAttributeSetter('emailOptIn', val)
  }

  get estimatedSKUCount () {
    return this.mapAttributeGetter('estimatedSKUCount')
  }

  set estimatedSKUCount (val) {
    this.mapAttributeSetter('estimatedSKUCount', val)
  }

  get firstName () {
    return this.mapAttributeGetter('firstName')
  }

  set firstName (val) {
    this.mapAttributeSetter('firstName', val)
  }

  get hasShippedAnOrder () {
    return this.mapAttributeGetter('hasShippedAnOrder')
  }

  set hasShippedAnOrder (val) {
    this.mapAttributeSetter('hasShippedAnOrder', val)
  }

  get hasURO () {
    return this.mapAttributeGetter('hasURO')
  }

  set hasURO (val) {
    this.mapAttributeSetter('hasURO', val)
  }

  get insertDate () {
    return this.mapAttributeGetter('insertDate')
  }

  set insertDate (val) {
    this.mapAttributeSetter('insertDate', val)
  }

  get internationalPricingPlanId () {
    return this.mapAttributeGetter('internationalPricingPlanId')
  }

  set internationalPricingPlanId (val) {
    this.mapAttributeSetter('internationalPricingPlanId', val)
  }

  get isAdmin () {
    return this.mapAttributeGetter('isAdmin')
  }

  set isAdmin (val) {
    this.mapAttributeSetter('isAdmin', val)
  }

  get isDemoUser () {
    return this.mapAttributeGetter('isDemoUser')
  }

  set isDemoUser (val) {
    this.mapAttributeSetter('isDemoUser', val)
  }

  get isLive () {
    return this.mapAttributeGetter('isLive')
  }

  set isLive (val) {
    this.mapAttributeSetter('isLive', val)
  }

  get isOnboarding () {
    return this.mapAttributeGetter('isOnboarding')
  }

  set isOnboarding (val) {
    this.mapAttributeSetter('isOnboarding', val)
  }

  get lastCompletedStep () {
    return this.mapAttributeGetter('lastCompletedStep')
  }

  set lastCompletedStep (val) {
    this.mapAttributeSetter('lastCompletedStep', val)
  }

  get lastCompletedStepName () {
    return this.mapAttributeGetter('lastCompletedStepName')
  }

  set lastCompletedStepName (val) {
    this.mapAttributeSetter('lastCompletedStepName', val)
  }

  get lastName () {
    return this.mapAttributeGetter('lastName')
  }

  set lastName (val) {
    this.mapAttributeSetter('lastName', val)
  }

  get lastSeen () {
    return this.mapAttributeGetter('lastSeen')
  }

  set lastSeen (val) {
    this.mapAttributeSetter('lastSeen', val)
  }

  get numberOfIntegrations () {
    return this.mapAttributeGetter('numberOfIntegrations')
  }

  set numberOfIntegrations (val) {
    this.mapAttributeSetter('numberOfIntegrations', val)
  }

  get numberOfRecievedWRO () {
    return this.mapAttributeGetter('numberOfRecievedWRO')
  }

  set numberOfRecievedWRO (val) {
    this.mapAttributeSetter('numberOfRecievedWRO', val)
  }

  get numberOfShipmentsPerMonth () {
    return this.mapAttributeGetter('numberOfShipmentsPerMonth')
  }

  set numberOfShipmentsPerMonth (val) {
    this.mapAttributeSetter('numberOfShipmentsPerMonth', val)
  }

  get oneDayEnabled () {
    return this.mapAttributeGetter('oneDayEnabled')
  }

  set oneDayEnabled (val) {
    this.mapAttributeSetter('oneDayEnabled', val)
  }

  get phoneNumber () {
    return this.mapAttributeGetter('phoneNumber')
  }

  set phoneNumber (val) {
    this.mapAttributeSetter('phoneNumber', val)
  }

  get shipOptionsSet () {
    return this.mapAttributeGetter('shipOptionsSet')
  }

  set shipOptionsSet (val) {
    this.mapAttributeSetter('shipOptionsSet', val)
  }

  get storeIntegrationNames () {
    return this.mapAttributeGetter('storeIntegrationNames')
  }

  set storeIntegrationNames (val) {
    this.mapAttributeSetter('storeIntegrationNames', val)
  }

  get twoDayEnabled () {
    return this.mapAttributeGetter('twoDayEnabled')
  }

  set twoDayEnabled (val) {
    this.mapAttributeSetter('twoDayEnabled', val)
  }

  get userGrowthExperimentId () {
    return this.mapAttributeGetter('userGrowthExperimentId')
  }

  set userGrowthExperimentId (val) {
    this.mapAttributeSetter('userGrowthExperimentId', val)
  }

  get userId () {
    return this.mapAttributeGetter('userId')
  }

  set userId (val) {
    this.mapAttributeSetter('userId', val)
  }

  get userRole () {
    return this.mapAttributeGetter('userRole')
  }

  set userRole (val) {
    this.mapAttributeSetter('userRole', val)
  }

  get whenReadyToShip () {
    return this.mapAttributeGetter('whenReadyToShip')
  }

  set whenReadyToShip (val) {
    this.mapAttributeSetter('whenReadyToShip', val)
  }

  isDefault () {
    return this.userId === 0
  }
}
